import { lazy } from "react";
import { ProductWrapperImport } from "src/components/ProductWrapper";

export default lazy(async () => {
  setTimeout(async () => {
    // preload ProductWrapper
    ProductWrapperImport();
  }, 5);

  return import(
    /* webpackChunkName: "Product" */
    "./Product.container"
  );
});
